import {gql, useApolloClient} from '@apollo/client';

export type Submitter = {
    guid: string;
    name: string;
    firstName: string;
    lastName: string;
    email: string | null;
};

type SubmittersByGuidsResponse = {
    submittersByGuids: Submitter[];
};

type SubmittersByGuidsVariables = {
    guids: string[];
};

const SUBMITTERS_BY_GUIDS_QUERY = gql`
    query SubmittersByGuids($guids: [UUID!]!) {
        submittersByGuids(guids: $guids) {
            guid
            name
            firstName
            lastName
            email
        }
    }
`;

export function useSubmittersByGuids(): (guids: string[]) => Promise<{data: SubmittersByGuidsResponse}> {
    const apolloClient = useApolloClient();

    return (guids: string[]) => apolloClient.query<SubmittersByGuidsResponse, SubmittersByGuidsVariables>({
        query: SUBMITTERS_BY_GUIDS_QUERY,
        variables: {guids},
        fetchPolicy: 'no-cache',
    });
}
